import { useSelector } from 'react-redux';
import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import TimeAgoTableCell from 'app/admin/device/component/TimeAgoTableCell';
import MeasurementTableService from '../service/MeasurementTableService';
// import MeasurementBulkDeleteButton from '../component/MeasurementBulkDeleteButton';
// import MeasurementBulkDownloadButton from '../component/MeasurementBulkDownloadButton';
// import GenererateEDAButton from '../component/GenerateEDAButton';
// import GenerateEDABulkButton from '../component/GenerateEDABulkButton';
// import MeasurementStartButton from '../component/MeasurementStartRecordingButton';
import MeasurementStartRecordingButton from '../component/MeasurementStartRecordingButton';
import MeasurementStopRecordingButton from '../component/MeasurementStopRecordingButton';
import MeasurementTimelineButton from '../component/MeasurementTimelineButton';
import MeasurementDownloadButton from '../component/MeasurementDownloadButton';
// import NewMeasurementToolbarButton from '../component/NewMeasurementToolbarButton';
import AddNewMeasurementToolbarButton from '../component/AddNewMeasurementToolbarButton';


const config = data => {
	return {
		key: 'measurementTable',
		text: 'Measurement',
		service: MeasurementTableService,
		toolbarAction: ['filter', 'search', 'refresh'],
		editFormState: item => `/measurement/edit/${item ? item.id : 'new'}`,
		// bulkSelection: true,
		bulkActionList: [
			// {
			// 	component: MeasurementBulkDeleteButton
			// },
			// {
			// 	component: MeasurementBulkDownloadButton
			// }
			/*{
				component: GenerateEDABulkButton
			}*/
		],
		rowButtonList: [
			{
				key: 'startRecordingMeasurement',
				component: MeasurementStartRecordingButton
			},
			{
				key: 'stopRecordingMeasurement',
				component: MeasurementStopRecordingButton
			},
			{
				key: 'download',
				component: MeasurementDownloadButton
			},
			{
				key: 'timelineMeasurement',
				component: MeasurementTimelineButton
			},
			// {
			// 	key: 'generateEDA',
			// 	component: GenererateEDAButton
			// },
			// {
			// 	key: 'startMeasurement',
			// 	component: MeasurementStartButton
			// },
			// {
			// 	key: 'stopMeasurement',
			// 	component: MeasurementStopButton
			// },
			// {
			// 	key: 'timelineMeasurement',
			// 	component: MeasurementTimelineButton
			// },
			// {
			// 	key: 'download',
			// 	component: MeasurementDownloadButton
			// }
		],
		toolbarActionList: [
			{
				key: 'startStreaming',
				component: AddNewMeasurementToolbarButton,
				type: 'stream'
			}
			// {
			// 	key: 'startRecording',
			// 	component: NewMeasurementToolbarButton,
			// 	type: 'record'
			// }
		],
		filterFields: [
			{
				propertyName: 'project',
				text: 'Project',
				propertyType: 'Long',
				type: 'IN',
				visibleIf: () => data.user.isSuperAdmin
			},
			{
				propertyName: 'device',
				text: 'Device',
				propertyType: 'Long',
				type: 'IN'
			},
			{
				propertyName: 'device.deviceType',
				text: 'Device Type',
				propertyType: 'Long',
				type: 'IN'
			},
			/*{
				propertyName: 'infrastructureElement',
				text: 'Infrastructure Element',
				propertyType: 'Long',
				type: 'IN'
			},*/
			{
				propertyName: 'created',
				text: 'Created',
				propertyType: 'Date',
				type: 'INTERVAL'
			},
			{
				propertyName: 'updated',
				text: 'Updated',
				propertyType: 'Date',
				type: 'INTERVAL'
			}
		],
		rowAction: [/*'fileOpen',*/'modify', 'delete'],
		fileOpenState: item => (item.file !== null ? `${nBossConnection.baseUrl}fileRepository/getFile?key=${item.file.key}` : null),
		columns: [
			{
				key: 'name',
				text: 'Name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'project.name',
				text: 'Project',
				type: 'text',
				sortable: true,
				disablePadding: false,
				// visibleIf: () => data.user.isSuperAdmin
			},
			{
				key: 'device.name',
				text: 'Device',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			/*{
				key: 'infrastructureElement.name',
				text: 'Infrastructure Element',
				textKey: 'infrastructureElement.name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},*/
			{
				key: 'location',
				text: 'Location',
				textKey: 'location',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			// {
			// 	key: 'status',
			// 	text: 'Status',
			// 	type: 'text',
			// 	sortable: true,
			// 	disablePadding: false
			// },
			// {
			// 	key: 'created',
			// 	text: 'Created',
			// 	type: 'dateTime',
			// 	sortable: true,
			// 	disablePadding: false
			// },
			// {
			// 	key: 'updated',
			// 	text: 'Updated',
			// 	type: 'dateTime',
			// 	sortable: true,
			// 	disablePadding: false
			// },
			// {
			// 	key: 'file.fileSize',
			// 	text: 'Size',
			// 	type: 'fileSize',
			// 	sortable: true,
			// 	disablePadding: false
			// }
			{
				key: 'created',
				text: 'Created',
				// type: 'dateTime',
				sortable: false,
				disablePadding: false,
				component: TimeAgoTableCell
			},
			{
				key: 'updated',
				text: 'Updated',
				// type: 'dateTime',
				sortable: false,
				disablePadding: false,
				component: TimeAgoTableCell
			}
		]
	};
};

function MeasurementTable() {
	const user = useSelector(({ auth }) => auth.user);
	const myConfig = config({ user });

	return <TableBrowser config={myConfig} />;
}

export default withReducer('measurementTable', reducer('measurementTable'))(MeasurementTable);
